import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";

import OptionCard from "./OptionCard";
import CustomButton from "../../../common/CustomButton";

import { GetSurveyQuestions } from "../../../redux/v2/user/actions";

import { apiCallV2 } from "../../../utils/api";
import { delay } from "../../../utils";

function Goals(props) {
    let checkboxRef = useRef(null);

    const { next, isShown } = props;
    const { account } = props.User;

    const [mostCommonArr, setMostCommonArr] = useState([]);
    const [otherDataArr, setOtherDataArr] = useState([]);
    const [searchArr, setSearchArr] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [selectedGoals, setSelectedGoals] = useState([]);

    const getData = async () => {
        const res = await apiCallV2("GET", "get-goals", "", localStorage.getItem("access-token"));
        if (res.status == 200) {
            setMostCommonArr(res.data.data.most_common);
            setOtherDataArr(res.data.data.other);
        }
    };

    const onChangeSearch = (e) => {
        let mergedArr = mostCommonArr.concat(otherDataArr);
        const matchedstr = mergedArr.map((arr) => {
            if (e.value.toUpperCase() != "" && arr.title.toUpperCase().includes(e.value.toUpperCase())) {
                return arr;
            }
        });

        matchedstr.length > 0 && e.value != "" ? setSearchArr(matchedstr.filter((arr) => arr)) : setSearchArr([]);
        setSearchValue(e.value);
    };

    const onClickNext = () => {
        if (selectedGoals.length == 3) {
            localStorage.setItem("goal_ids", JSON.stringify(selectedGoals));
            next();

            props.GetSurveyQuestions(selectedGoals);
        }
    };

    const handleSelection = (id) => {
        let temp = [...selectedGoals];

        if (temp.includes(id)) {
            temp = temp.filter((s) => s != id);
        } else {
            if (temp.length < 3) {
                temp.push(id);
            }
        }

        setSelectedGoals(temp);
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (mostCommonArr.length > 0 && isShown) {
            var elem = document.getElementById("activities-list");
            delay(() => {
                elem.scrollTo({
                    top: 150,
                    behavior: "smooth",
                });

                delay(() => {
                    elem.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }, 500);
            }, 200);
        }
    }, [mostCommonArr.length, isShown]);

    useEffect(() => {
        if (account?.surveys?.length > 0) {
            const latest = account?.surveys[account?.surveys.length - 1];
            setSelectedGoals([latest?.goal1, latest?.goal2, latest?.goal3]);
        }
    }, [account?.user?.userID]);


    return (
        <div id="gs-v2-goals" className="custom-card goal-page">
            <form className="details-form">
                <p className="ta-c">Select the top three activities or goals you're looking to achieve in your health & fitness.</p>
                <div className="input-field search-field">
                    <TextBoxComponent className="field" name="inputName" type="text" placeholder="Search" onChange={(e) => onChangeSearch(e)} />
                </div>

                {searchArr.length > 0 ? (
                    <div id="activities-list">
                        {searchArr.length > 0 &&
                            searchArr.map((op) => {
                                let isSelected = selectedGoals.includes(op.id);
                                let disable = selectedGoals.length > 2 && !isSelected;

                                return (
                                    <OptionCard
                                        text={op.title}
                                        selected={isSelected}
                                        disabled={disable}
                                        onClick={(e) => {
                                            handleSelection(op.id);
                                        }}
                                    />
                                );
                            })}
                    </div>
                ) : searchValue != "" ? (
                    <div>
                        <label>No match found</label>
                    </div>
                ) : (
                    <div id="activities-list" ref={checkboxRef}>
                        <div className="checkbox-part">
                            <p>MOST COMMON</p>
                            {mostCommonArr.length > 0 &&
                                mostCommonArr.map((op, i) => {
                                    let isSelected = selectedGoals.includes(op.id);
                                    let disable = selectedGoals.length > 2 && !isSelected;

                                    return (
                                        <OptionCard
                                            key={"mc-oc-" + i}
                                            text={op.title}
                                            selected={isSelected}
                                            disabled={disable}
                                            onClick={(e) => {
                                                handleSelection(op.id);
                                            }}
                                        />
                                    );
                                })}
                        </div>
                        <div className="checkbox-part">
                            <p>OTHER</p>
                            {otherDataArr.length > 0 &&
                                otherDataArr.map((op, i) => {
                                    let isSelected = selectedGoals.includes(op.id);
                                    let disable = selectedGoals.length > 2 && !isSelected;

                                    return (
                                        <OptionCard
                                            key={"o-oc-" + i}
                                            text={op.title}
                                            selected={isSelected}
                                            disabled={disable}
                                            onClick={(e) => {
                                                handleSelection(op.id);
                                            }}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                )}
            </form>
            <div>
                <CustomButton className={`${selectedGoals.length == 3 ? "select-completed" : "select-not-completed"}`} onClick={onClickNext}>
                    Next
                </CustomButton>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    GetSurveyQuestions,
})(Goals);
